import { api } from '@/shared/lib/api'
import { useQuery } from '@tanstack/react-query'

export const useGetAttachmentTree = (id: string, enabled: boolean = true) => {
    return useQuery({
        queryKey: ['attachment-tree', id],
        queryFn: () => api.attachment.getFolderTree(id),
        enabled: enabled && !!id,
        meta: {
            skipGlobalErrorHandler: true,
        },
    })
}
